import React from "react";
import TriunfoImage from "../../../images/driving/triunfo.png"; // TODO: get SVG file
import Typography from "material-ui/Typography";
import "./NoDrivingEvents.css";

const NoDrivingEvents = ({ lang }) => {
  return (
    <div className="no-driving-events">
      <img src={TriunfoImage} alt="triunfo" />
      <Typography
        variant="headline"
        component="h1"
        align="center"
        className="value"
      >
        {lang.Muybien}
      </Typography>
      <Typography component="p" align="center" className="title">
        {lang.SinEventosDriving}
      </Typography>
    </div>
  );
};

export default NoDrivingEvents;



// WEBPACK FOOTER //
// ./src/containers/Driving/DrivingEventVisualizations/NoDrivingEvents.js